var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"main-footer"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"pull-right hidden-xs"},[_c('b',[_vm._v("School of Public Health")])]),_c('strong',[_vm._v("Copyright © 2024.")]),_vm._v(" All rights reserved. ")])])
}]

export { render, staticRenderFns }